module.exports = __webpack_public_path__ + "media/components/common/formParts/img/dotted-line-13182971fd09675b6a1dfbdbaf0328bb.png";